<template>
	<div class="pxrwwfgv-fullscreen-alert" @click="enterFullscreen">
		<div class="pxrwwfgv-fullscreen-alert-inner">
			<LottieAnimation 
				:animation-data="DeviceRotationLottie"
				:auto-play="true"
				:loop="true"
				class="pxrwwfgv-devicerot-lottie"
			/>
			<LottieAnimation 
				:animation-data="TouchLottie"
				:auto-play="true"
				:loop="true"
				class="pxrwwfgv-touch-lottie"
			/>
		</div>
	</div>
</template>

<script setup >
	import { inject } from 'vue';
	import { LottieAnimation } from 'lottie-web-vue'
	import DeviceRotationLottie from '@/assets/lotties/device_rotation.json'
	import TouchLottie from '@/assets/lotties/touch.json'
	import { useFullscreen, useScreenOrientation } from '@vueuse/core'

	const viewportContainer = inject('viewportContainer');

	const {isFullscreen, enter } = useFullscreen(viewportContainer);
	const {isSupported: soIsSupported, lockOrientation} = useScreenOrientation();

	function enterFullscreen(){
		if(isFullscreen.value || !soIsSupported.value){
			return;
		}

		enter();
		lockOrientation('landscape');
	}
</script>

<style scoped>
	.pxrwwfgv-fullscreen-alert {
		position: absolute;
		z-index: 100;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgb(188 231 242 / 80%);
		cursor: pointer;
	}
	.pxrwwfgv-fullscreen-alert-inner {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.pxrwwfgv-devicerot-lottie {
		position: absolute;
		top: 50px;
		z-index: 1;
		width: 500px;
		height: auto;
		pointer-events: none;
	}
	.pxrwwfgv-touch-lottie {
		position: absolute;
		bottom: 50px;
		z-index: 2;
		width: 500px;
		height: auto;
		pointer-events: none;
	}
</style>
